var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _path12, _path13, _path14, _path15, _path16, _g11, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliverRankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17282_55052)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 0,
    width: 22,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint0_linear_17282_55052)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint1_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 36,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint2_linear_17282_55052)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint3_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 44,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint4_linear_17282_55052)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint5_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 44,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint6_linear_17282_55052)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint7_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 65,
    width: 36,
    height: 43
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint8_linear_17282_55052)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint9_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 71,
    width: 22,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint10_linear_17282_55052)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint11_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 65,
    width: 36,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint12_linear_17282_55052)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint13_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 56,
    width: 44,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint14_linear_17282_55052)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint15_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 28,
    width: 44,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint16_linear_17282_55052)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint17_linear_17282_55052)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 4,
    width: 36,
    height: 43
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint18_linear_17282_55052)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint19_linear_17282_55052)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.071 85.3508C75.4402 85.3508 91.142 69.6022 91.142 50.1754C91.142 30.7486 75.4402 15 56.071 15C36.7018 15 21 30.7486 21 50.1754C21 69.6022 36.7018 85.3508 56.071 85.3508Z",
    fill: "url(#paint20_linear_17282_55052)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0714 83.0954C74.1986 83.0954 88.8937 68.3566 88.8937 50.1754C88.8937 31.9942 74.1986 17.2554 56.0714 17.2554C37.9441 17.2554 23.249 31.9942 23.249 50.1754C23.249 68.3566 37.9441 83.0954 56.0714 83.0954Z",
    fill: "url(#paint21_linear_17282_55052)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0713 81.7931C73.4812 81.7931 87.5947 67.6376 87.5947 50.1758C87.5947 32.7141 73.4812 18.5586 56.0713 18.5586C38.6614 18.5586 24.5479 32.7141 24.5479 50.1758C24.5479 67.6376 38.6614 81.7931 56.0713 81.7931Z",
    fill: "url(#paint22_linear_17282_55052)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1914 93.0699C75.3869 95.0451 73.4036 96.516 71.5739 95.7315L62.5373 91.8931L56.1125 89.1615L49.6877 91.8931L40.5673 95.7875C38.7656 96.558 36.7962 95.1291 36.9499 93.1819L39.2265 63.1196H72.2583L75.1914 93.0699Z",
    fill: "url(#paint23_linear_17282_55052)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5654 69.6899V91.9075L56.1406 89.1758L49.7158 91.9075V69.6899H62.5654Z",
    fill: "#EDF5FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_17282_55052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 27,
    width: 52,
    height: 51
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1366 29.4296C63.5864 25.6053 69.9134 28.2249 69.662 33.38C69.4944 36.63 72.1621 39.3056 75.4024 39.1375C80.5423 38.8713 83.1681 45.2312 79.3411 48.6913C76.9388 50.8626 76.9388 54.6589 79.3411 56.8303C83.1541 60.2904 80.5423 66.6362 75.4024 66.3841C72.1621 66.216 69.4944 68.8916 69.662 72.1416C69.9274 77.2967 63.5864 79.9303 60.1366 76.092C57.9717 73.6825 54.1867 73.6825 52.0218 76.092C48.5719 79.9163 42.2449 77.2967 42.4963 72.1416C42.6639 68.8916 39.9962 66.216 36.7559 66.3841C31.6161 66.6502 28.9903 60.2904 32.8172 56.8303C35.2195 54.6589 35.2195 50.8626 32.8172 48.6913C29.0043 45.2312 31.6161 38.8853 36.7559 39.1375C39.9962 39.3056 42.6639 36.63 42.4963 33.38C42.2309 28.2249 48.5719 25.5913 52.0218 29.4296C54.1867 31.8391 57.9577 31.8391 60.1366 29.4296Z",
    fill: "url(#paint24_linear_17282_55052)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_17282_55052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 29.4286C63.5854 25.6043 69.9125 28.2239 69.661 33.379C69.4934 36.629 72.1611 39.3046 75.4015 39.1365C80.5413 38.8704 83.1671 45.2302 79.3401 48.6903C76.9378 50.8617 76.9378 54.658 79.3401 56.8293C83.1531 60.2894 80.5413 66.6352 75.4015 66.3831C72.1611 66.215 69.4934 68.8906 69.661 72.1406C69.9264 77.2957 63.5854 79.9293 60.1356 76.091C57.9707 73.6815 54.1857 73.6815 52.0208 76.091C48.571 79.9153 42.2439 77.2957 42.4953 72.1406C42.6629 68.8906 39.9953 66.215 36.7549 66.3831C31.6151 66.6493 28.9893 60.2894 32.8163 56.8293C35.2186 54.658 35.2186 50.8617 32.8163 48.6903C29.0033 45.2302 31.6151 38.8844 36.7549 39.1365C39.9953 39.3046 42.6629 36.629 42.4953 33.379C42.23 28.2239 48.571 25.5903 52.0208 29.4286C54.1857 31.8381 57.9568 31.8381 60.1356 29.4286Z",
    fill: "url(#paint25_linear_17282_55052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1356 26.8368C63.5854 23.0125 69.9125 25.6321 69.661 30.7872C69.4934 34.0372 72.1611 36.7128 75.4015 36.5447C80.5413 36.2786 83.1671 42.6384 79.3401 46.0985C76.9378 48.2699 76.9378 52.0662 79.3401 54.2375C83.1531 57.6976 80.5413 64.0435 75.4015 63.7913C72.1611 63.6232 69.4934 66.2988 69.661 69.5488C69.9264 74.704 63.5854 77.3376 60.1356 73.4992C57.9707 71.0898 54.1857 71.0898 52.0208 73.4992C48.571 77.3236 42.2439 74.704 42.4953 69.5488C42.6629 66.2988 39.9953 63.6232 36.7549 63.7913C31.6151 64.0575 28.9893 57.6976 32.8163 54.2375C35.2186 52.0662 35.2186 48.2699 32.8163 46.0985C29.0033 42.6384 31.6151 36.2926 36.7549 36.5447C39.9953 36.7128 42.6629 34.0372 42.4953 30.7872C42.23 25.6321 48.571 22.9985 52.0208 26.8368C54.1857 29.2603 57.9568 29.2603 60.1356 26.8368Z",
    fill: "url(#paint26_linear_17282_55052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7887 50.1754C72.7887 50.6657 72.7748 51.142 72.7189 51.6183C71.9926 60.2055 64.8136 66.9436 56.0703 66.9436C47.327 66.9436 40.148 60.2055 39.4077 51.6183C39.3658 51.142 39.3379 50.6517 39.3379 50.1754C39.3379 40.9158 46.8242 33.4072 56.0563 33.4072C65.3024 33.4072 72.7887 40.9158 72.7887 50.1754Z",
    fill: "url(#paint27_linear_17282_55052)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0489 41.927C55.3483 41.0057 56.6517 41.0057 56.9511 41.9271L58.2451 45.9098C58.379 46.3219 58.763 46.6008 59.1962 46.6008H63.3839C64.3527 46.6008 64.7554 47.8404 63.9717 48.4098L60.5838 50.8713C60.2333 51.126 60.0866 51.5773 60.2205 51.9894L61.5146 55.9721C61.8139 56.8934 60.7595 57.6596 59.9757 57.0902L56.5878 54.6287C56.2373 54.374 55.7627 54.374 55.4122 54.6287L52.0243 57.0902C51.2405 57.6596 50.1861 56.8934 50.4854 55.9721L51.7795 51.9894C51.9134 51.5773 51.7667 51.126 51.4162 50.8713L48.0283 48.4098C47.2446 47.8404 47.6473 46.6008 48.6161 46.6008H52.8038C53.237 46.6008 53.621 46.3219 53.7549 45.9098L55.0489 41.927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17282_55052",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17282_55052",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17282_55052",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17282_55052",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17282_55052",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17282_55052",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17282_55052",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17282_55052",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17282_55052",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17282_55052",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17282_55052",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17282_55052",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17282_55052",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17282_55052",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17282_55052",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17282_55052",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17282_55052",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17282_55052",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17282_55052",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17282_55052",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_17282_55052",
    x1: 56.0753,
    y1: 85.3435,
    x2: 56.0753,
    y2: 14.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCAE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_17282_55052",
    x1: 56.0757,
    y1: 83.0845,
    x2: 56.0757,
    y2: 17.2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F678F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51587C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_17282_55052",
    x1: 56.0756,
    y1: 81.7861,
    x2: 56.0756,
    y2: 18.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828DBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17282_55052",
    x1: 56.075,
    y1: 95.996,
    x2: 56.075,
    y2: 63.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52577B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_17282_55052",
    x1: 56.0765,
    y1: 77.9078,
    x2: 56.0765,
    y2: 27.6034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_17282_55052",
    x1: 56.0755,
    y1: 77.9068,
    x2: 56.0755,
    y2: 27.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51587C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_17282_55052",
    x1: 30.998,
    y1: 50.171,
    x2: 81.1531,
    y2: 50.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEBBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_17282_55052",
    x1: 56.0746,
    y1: 66.9396,
    x2: 56.0746,
    y2: 33.4032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B5075"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17282_55052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.727,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliverRankIcon);
export default __webpack_public_path__ + "static/media/SliverRankIcon.9f5cc792.svg";
export { ForwardRef as ReactComponent };